<template>
  <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li v-for="item in items" :key="item.id" :class="item.active ? 'active' : ''">
              <a v-if="item.link" :href="item.link"><i v-if="item.icon" class="item.icon"></i> {{item.title}}</a>
              {{item.link ? '' : item.title}}
            </li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ["items"]
}
</script>
